import { NavigateCommand } from './types';

export const handleNavigationCommand = (
  command: NavigateCommand,
  navigate: any
): void => {
  try {
    navigate(command.data.to, command.data.params);
  } catch (ex) {
    console.log('Navigation Error: ', ex);
  }
};
